import { Brick, registerBrick } from 'olympe'
import { getApplicationContext } from '../utils/Context';

export default class CallProxyJSON extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (headers, path, proxiedPath, payload, token, operation) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} headers
     * @param {string} path
     * @param {string} proxiedPath
     * @param {*} payload
     * @param {string} token
     * @param {string} operation
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(string)} setResponse
     */
    onUpdate(
        context,
        [headers, path, proxiedPath, payload, token, operation],
        [forwardEvent, setErrorFlow, setResponse]
    ) {
        console.log("headers, path, proxiedPath, payload, token, operation", headers, path, proxiedPath, payload, token, operation)
        const access_token = sessionStorage.getItem("ms_auth_token");
        const token_Access = getApplicationContext(context).get("ms_auth_token");
        let headersObject = JSON.parse(headers);
        // Add the authorizastion token safely
        headersObject.Authorization = `Bearer ${token_Access}`;
        console.log("::: Updated headers Object :::", headersObject)
        const body = {
            destination: proxiedPath,
            token: token,
            headers: headersObject,
            opperation: operation,
            payload: payload,
        }
        fetch(path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                console.log(" CallProxyJSON:: response object now:", data);
                setResponse(JSON.stringify(data))
                forwardEvent()
            })
            .catch(error => {
                console.error('CallProxyJSON::Error:', error)
                setErrorFlow(error)
            })
    }
}

registerBrick('017ce01306f4500f4547', CallProxyJSON)
